/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/prefer-default-export */
import * as React from "react";
import { Button, Heading } from "@components";
import classNames from "classnames";

import { useProductContext } from "../../../context/ProductContext";
import usePriceFormatter from "../../../hooks/usePriceFormatter";
import useStickyProductForm from "../../../hooks/useStickyProductForm";
import selectors from "../selectors";

interface MiniProductFormProps {
  title: string;
  disabled?: boolean;
  ctaContent: React.ReactNode;
  onAddToCart: () => void;
}

/**
 * Compact version of the product form that sticks to
 * the bottom/top of the screen on scroll
 */
export function MiniProductForm({
  title,
  ctaContent,
  disabled,
  onAddToCart,
}: MiniProductFormProps) {
  const { variant } = useProductContext();
  const formatPrice = usePriceFormatter();

  const { stickyFormProps: props, referenceElementProps } =
    useStickyProductForm();

  return (
    <>
      <span {...referenceElementProps} />
      <aside
        {...props}
        data-testid={selectors.ctaMiniAside}
        className={classNames(
          "fixed z-10 bottom-0 inset-x-0 border-t border-flint/10",
          "bg-white/90 backdrop-blur-[20px] transition duration-400",
          {
            "transform translate-y-full pointer-events-none":
              !!props["aria-hidden"],
          }
        )}
      >
        <div className="flex flex-col lg:px-10 lg:py-2 lg:container lg:mx-auto lg:flex-row">
          {/* Title & Price box */}
          <div className="flex items-center justify-between gap-4 px-4 py-2 lg:flex-auto lg:justify-start">
            <Heading as="h4" variant="h5" className="!text-base">
              {title}
            </Heading>

            {variant.available && <p>{formatPrice(variant.price)}</p>}
          </div>

          {/* Add to cart button */}
          <Button
            className="font-light uppercase whitespace-nowrap lg:min-w-[195px]"
            variant="pine-to-dark"
            data-testid={selectors.ctaButtonMini}
            disabled={disabled}
            type="submit"
            onClick={onAddToCart}
          >
            {ctaContent}
          </Button>
        </div>
      </aside>
    </>
  );
}
